import styled, { css } from 'styled-components';
import { Atom } from 'AppReact';
import device from 'utils/device';

export const template = styled.textarea`
  ${({ theme, displayState }) => css`
    width: ${displayState?.width ?? '100%'};
    height: ${displayState?.height ?? '42px'};
    min-height: ${displayState?.minHeight ?? ''};
    resize: ${displayState?.resize ?? 'none'};
    outline: none;
    
    padding: 8px;

    font-size: ${displayState?.fontSize ?? '12px'};
    font-weight: 400;
    color: ${theme?.colour?.secondary ?? "#04333b"};
    border: ${`1px solid ${displayState?.borderColor ?? '#E3E3E3'}`};
    border-radius: 8px;
    overflow-y: auto;

    ::placeholder {
      color: #9EACB0;
    }

    &:disabled {
      color: #E3E3E3;
      background-color: unset;
    }

    &:focus {
      border: 1px solid ${displayState?.borderColor ?? theme?.colour?.primary ?? '#1DBD6B'};
    }


    scrollbar-width: thin;
    scrollbar-color: #E3E3E3 transparent;
    /* width */
    ::-webkit-scrollbar {
      width: 4px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
      border-radius: 10px;
    }
    
    /* Handle */
    ::-webkit-scrollbar-thumb {
      background: ${theme?.colour?.primary ?? '#1DBD6B'}; 
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
      background: ${theme?.colour?.primary ?? '#1DBD6B'}; 
    }

    @media ${device.tablet} {
      font-size: ${displayState?.fontSize ?? '16px'};
    }
  `}
`;

export default Atom({ type: 'textareaGrow', dataType: 'string', template })
